import gql from 'graphql-tag'

export const CREATE_TRAINER = gql`
  mutation academyCreateTrainer($trainer: TrainerInput!) {
    academyCreateTrainer(trainer: $trainer) {
      id
      desc
      websiteUrl
      name
      email
      media {
        id
        url
      }
    }
  }
`

export const UPDATE_TRAINER = gql`
  mutation academyUpdateTrainer($trainerId: Int!, $trainer: TrainerInput!) {
    academyUpdateTrainer(trainerId: $trainerId, trainer: $trainer) {
      id
      desc
      websiteUrl
      name
      email
      media {
        id
        url
      }
    }
  }
`

export const REMOVE_TRAINERS = gql`
  mutation academyRemoveTrainers($trainerIds: [Int!]) {
    academyRemoveTrainers(trainerIds: $trainerIds)
  }
`
